import { InjectionToken } from '@angular/core';
import { CmsComponent } from '@core/models/atomics.model';
import { CxAbstractComponentProvider, CxAbstractSectionProvider } from '@b2b/components/cms/cx-abstract/cx-abstract.types';

export const CX_ABSTRACT_COMPONENT = new InjectionToken<CxAbstractComponentProvider[]>('CX_ABSTRACT_COMPONENT');
export const CX_ABSTRACT_COMPONENT_DATA = new InjectionToken<CmsComponent>('CX_ABSTRACT_COMPONENT_DATA');

export const CX_ABSTRACT_SECTION = new InjectionToken<CxAbstractSectionProvider[]>('CX_ABSTRACT_SECTION');
export const CX_ABSTRACT_SECTION_COMPONENTS = new InjectionToken<CmsComponent[]>('CX_ABSTRACT_SECTION_COMPONENTS');
